import { combineReducers } from 'redux';
import { payments } from './payments/payments';
import { recurringReceivables } from './recurringReceivables/recurringReceivables';

export const pagination = combineReducers({
  payments,
  recurringReceivables,
});
